import NetworkIcon from './NetworkIcon'

export default NetworkIcon
